<script setup lang="ts">
import { isAppUsing } from '@@/bits/flip'
import type { Section } from '@@/types'
import SurfacePostGroupHeaderSection from '@@/vuecomponents/SurfacePostGroupHeaderSection.vue'
import SurfacePostGroupHeaderSectionOld from '@@/vuecomponents/SurfacePostGroupHeaderSectionOld.vue'

defineProps<{
  section: Section
}>()
</script>

<template>
  <SurfacePostGroupHeaderSection
    v-if="isAppUsing('groupPostsV2')"
    :section="section"
    style="transform: rotate(-2deg)"
  />
  <SurfacePostGroupHeaderSectionOld v-else :section="section" style="transform: rotate(-2deg)" />
</template>
